<template>
  <div>
    <!-- 时间区间汇总 -->
    <div v-if="item.isFirstOfPeriod" class="time_range_wrap">
      <p class="time_range_label">{{ item.membershipPeriod }}</p>
      <p v-if="isTodayInRange()" class="time_range_desc">{{ $t('FoodC_bill_xdYa_VuVu') }}</p>
      <div class="time_range_item">
        <p class="time_range_item_label_text">{{ $t('FoodC_bill_VODO_nrnN') }}</p>
        <p class="time_range_item_label_amount">{{ totalSaved(item) }}</p>
      </div>
    </div>
    <!-- 外卖&商超 -->
    <div v-if="bizLine.includes(item.bizLine)" class="order_list_wrap">
      <div class="order_list_item_left">
        <p class="order_list_item_label_text">{{ item.shop_name }}</p>
        <p class="order_list_item_date">{{ item.orderTime }}</p>
      </div>
      <div class="order_list_item_right">
        <p class="order_list_item_label_amount">{{ item.savingMoney }}</p>
        <p class="order_list_item_saved">{{ $t('FoodC_bill_MFfk_WhCz') }}</p>
      </div>
    </div>
    <!-- 出行&闪送 -->
    <div v-else class="trip_wrap">
      <div class="trip_item">
        <div class="trip_item_left">
          <div class="trip_item_left_set">
            <i class="trip_item_left_dot" />
            <div class="trip_item_left_set_text">{{ item.startPoint }}</div>
          </div>
          <div class="trip_item_left_destination">
            <i class="trip_item_left_dot color_orange" />
            <div class="trip_item_left_destination_text">{{ item.endPoint }}</div>
          </div>
        </div>
        <div class="trip_item_right">
          <div class="trip_item_right_amount">{{ item.savingMoney }}</div>
          <div class="trip_item_right_saved">{{ $t('FoodC_bill_MFfk_WhCz') }}</div>
        </div>
      </div>
      <p class="trip_date">{{ item.orderTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberCard',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    membershipPeriod: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      bizLine: ['Food', 'Shop'],
    }
  },
  computed: {},
  mounted() {},
  methods: {
    totalSaved() {
      return this.membershipPeriod[this.item.membershipPeriod]?.totalSaved
    },
    // 检查今天是否在指定的日期范围内
    isTodayInRange() {
      const parseDate = str => {
        const [dd, mm, yyyy] = str.split('/')
        return new Date(`${yyyy}-${mm}-${dd}`).setHours(0, 0, 0, 0)
      }
      // 获取总节省金额的日期范围
      const [startStr, endStr] = this.item.membershipPeriod.split('-')
      // 将开始和结束日期字符串转换为Date对象
      const start = parseDate(startStr.trim())
      const end = parseDate(endStr.trim())
      const today = new Date().setHours(0, 0, 0, 0)
      // 检查今天是否在指定的日期范围内
      return today >= start && today <= end
    },
  },
}
</script>

<style lang="scss" scoped>
.time_range_wrap {
  background: #f5f5f7;
  border-radius: 40px;
  padding: 40px 32px;
  margin-bottom: 48px;
  .time_range_label {
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 36px;
    color: #0b0b0d;
    line-height: 44px;
  }
  .time_range_desc {
    font-family: DiDiSans-Pro-Regular;
    font-size: 20px;
    color: #89898c;
    line-height: 28px;
    margin-top: 4px;
  }
  .time_range_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 36px;
    font-size: 28px;
    margin-top: 24px;
    .time_range_item_label_text {
      font-family: DiDiSans-Pro-Regular;
      color: #0b0b0d;
    }
    .time_range_item_label_amount {
      font-family: DiDiSans-Pro-Bold;
      color: #0b0b0d;
    }
  }
}
.order_list_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 64px;
  .order_list_item_left {
    font-size: 28px;
    width: calc(100% - 48px);
    margin-right: 48px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .order_list_item_label_text {
      margin-bottom: 12px;
      font-family: DiDiSans-Pro-Medium;
      color: #0b0b0d;
      line-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .order_list_item_date {
      font-family: DiDiSans-Pro-Regular;
      color: #89898c;
      line-height: 36px;
    }
  }
  .order_list_item_right {
    font-size: 28px;
    text-align: right;
    .order_list_item_label_amount {
      margin-bottom: 12px;
      font-family: DiDiSans-Pro-Bold;
      color: #ff5f14;
      line-height: 36px;
    }

    .order_list_item_saved {
      font-family: DiDiSans-Pro-Regular;
      color: #89898c;
      line-height: 36px;
    }
  }
}
.trip_wrap {
  margin-bottom: 64px;
  .trip_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .trip_item_left {
      color: #0b0b0d;
      font-size: 28px;
      // margin-right: 48px;
      width: calc(100% - 48px);
      margin-right: 48px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .trip_item_left_dot {
        display: inline-block;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background: #1bb17c;
        border: 4px solid #ffffff;
        box-shadow: 0px 1px 4px 0px rgba(92, 97, 102, 0.1);
        margin-right: 12px;
      }
      .color_orange {
        background: #ff7a45;
      }
      .trip_item_left_set {
        font-family: DiDiSans-Pro-Medium;
        line-height: 36px;
        display: flex;
        align-items: center;
        display: flex;
        align-items: center;
        width: 100%;
      }
      .trip_item_left_set_text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .trip_item_left_destination {
        display: flex;
        align-items: center;
        font-family: DiDiSans-Pro-Medium;
        line-height: 36px;
        margin-top: 4px;
      }
      .trip_item_left_destination_text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .trip_item_right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-size: 28px;
      .trip_item_right_amount {
        font-family: DiDiSans-Pro-Bold;
        color: #ff5f14;
        line-height: 36px;
      }
      .trip_item_right_saved {
        font-family: DiDiSans-Pro-Regular;
        color: #89898c;
        line-height: 36px;
        margin-top: 12px;
      }
    }
  }
  .trip_date {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #89898c;
    line-height: 36px;
    margin-top: 12px;
  }
}
</style>
